<mat-toolbar class="main-header">
  @if (sidenav.mode === "over") {
    <button mat-icon-button (click)="toggleMenu()">
      @if (!sidenav.opened) {
        <mat-icon>menu</mat-icon>
      }
      @if (sidenav.opened) {
        <mat-icon>close</mat-icon>
      }
    </button>
  }
  <span>Clasificación</span>
  <span class="spacer"></span>
  @if (liveMatches && liveMatches.length > 0) {
    <span class="live-indicator">
      <span class="pulse-dot"></span>EN DIRECTO
    </span>
  }
  <div
    class="standings-filter-toggles"
    role="group"
    aria-label="Opciones de puntuación"
  >
    <button
      type="button"
      class="standings-filter-toggle standings-filter-toggle--pichichi"
      [class.active]="includeTemporaryPichichi"
      [attr.aria-pressed]="includeTemporaryPichichi"
      [attr.aria-label]="
        includeTemporaryPichichi
          ? 'Excluir pichichi temporal'
          : 'Incluir pichichi temporal'
      "
      [title]="
        includeTemporaryPichichi
          ? 'Pichichi temporal incluido'
          : 'Incluir pichichi temporal'
      "
      (click)="toggleTemporaryPichichi()"
    >
      <mat-icon>sports_soccer</mat-icon>
      <span class="standings-filter-label">Pichichi</span>
      <span class="standings-filter-status" aria-hidden="true"></span>
    </button>
    <button
      type="button"
      class="standings-filter-toggle standings-filter-toggle--jokers"
      [class.active]="includeJokers"
      [attr.aria-pressed]="includeJokers"
      [attr.aria-label]="includeJokers ? 'Excluir Jokers' : 'Incluir Jokers'"
      [title]="includeJokers ? 'Jokers incluidos' : 'Jokers excluidos'"
      (click)="toggleJokers()"
    >
      <img src="/assets/imgs/joker-on.svg" alt="" />
      <span class="standings-filter-label">Jokers</span>
      <span class="standings-filter-status" aria-hidden="true"></span>
    </button>
  </div>
  <button
    mat-icon-button
    aria-label="Actualizar clasificación"
    title="Actualizar clasificación"
    (click)="reload()"
  >
    <mat-icon>refresh</mat-icon>
  </button>
</mat-toolbar>

@if (isAdmin || groups.length > 0) {
  <div class="group-bar">
    <div class="group-bar-scroll">
      <button
        type="button"
        class="group-chip"
        [class.active]="groupSelected === 'general'"
        (click)="selectGroup('general')"
      >
        🌍 General
      </button>
      @for (group of groups; track group) {
        <button
          type="button"
          class="group-chip"
          [class.active]="groupSelected === group._id"
          (click)="selectGroup(group._id)"
        >
          {{ group.name }}
        </button>
      }
    </div>
  </div>
}

<div class="standings-page">
  @if (liveMatches && liveMatches.length > 0) {
    <section class="live-section">
      <!-- <div class="section-label">
        <span class="pulse-dot"></span>Partidos en juego
      </div> -->
      @for (match of liveMatches; track match) {
        <div class="live-card">
          <div class="live-scoreboard">
            <div class="live-strip">
              <div class="live-team live-team--home">
                <img
                  class="live-flag"
                  src="{{ match.homeTeam.flag }}"
                  alt="{{ match.homeTeam.name }}"
                />
                <span class="live-team-code">{{
                  getTeamCode(match.homeTeam)
                }}</span>
              </div>
              <span class="live-goals">
                <span>{{ match.homeGoals }}</span>
              </span>
              <span class="live-cup">
                <img src="/assets/logo.png" alt="World Cup 2026" />
              </span>
              <span class="live-goals">
                <span>{{ match.awayGoals }}</span>
              </span>
              <div class="live-team live-team--away">
                <span class="live-team-code">{{
                  getTeamCode(match.awayTeam)
                }}</span>
                <img
                  class="live-flag"
                  src="{{ match.awayTeam.flag }}"
                  alt="{{ match.awayTeam.name }}"
                />
              </div>
            </div>
            <div class="live-clock">{{ getLiveClockLabel(match) }}</div>
            @if (getLivePhaseScoreLabel(match); as phaseScoreLabel) {
              <div class="live-phase-score">{{ phaseScoreLabel }}</div>
            }
          </div>
          <app-match-stats
            [match]="match"
            variant="live"
            (usersSelected)="showUsers($event)"
          ></app-match-stats>
          <div class="my-pred">
            <span>Mi pronóstico:</span>
            <strong
              >{{ match.userHomeGoals }} – {{ match.userAwayGoals }}</strong
            >
            @if (match.useJoker) {
              <img src="/assets/imgs/joker-on.svg" class="pred-joker" />
            }
          </div>
        </div>
      }
    </section>
  }

  @if (standings && standings.length >= 3) {
    <div class="podium">
      <div
        class="podium-card silver"
        [class.is-me]="standings[1].user._id == loggedUser._id"
        (click)="selectUser(standings[1].user)"
      >
        <div class="podium-medal">🥈</div>
        <div class="podium-avatar-wrap">
          <app-avatar [user]="standings[1].user"></app-avatar>
        </div>
        <div class="podium-name">{{ standings[1].user.name }}</div>
        @if (
          currentTimestamp >= firstRoundIniTimestamp &&
          standings[1].championFlag
        ) {
          <div
            class="podium-champion"
            title="Campeón: {{ standings[1].championName }}"
          >
            <img
              [src]="standings[1].championFlag"
              [alt]="standings[1].championName"
            />
            <span>{{ standings[1].championName }}</span>
          </div>
        }
        <div class="podium-pts">
          {{ standings[1].points }}<small>pts</small>
        </div>
        <div class="podium-jokers">
          {{ standings[1].jokersConsumed
          }}<img src="/assets/imgs/joker-on.svg" />
        </div>
        @if (
          currentTimestamp >= firstRoundIniTimestamp &&
          standings[1].pichichiLabel
        ) {
          <div class="podium-pichichi">
            <span class="podium-pichichi-icon">⚽</span>
            <span class="podium-pichichi-name">{{
              standings[1].pichichiLabel
            }}</span>
          </div>
        }
        @if (standings[1].currentResults) {
          <div class="podium-live">
            @for (r of standings[1].currentResults; track r) {
              <span
                >{{ getLivePredictionLabel(r) }}
                @if (r.useJoker) {
                  <img src="/assets/imgs/joker-on.svg" class="tiny-joker" />
                }
              </span>
            }
          </div>
        }
      </div>

      <div
        class="podium-card gold first"
        [class.is-me]="standings[0].user._id == loggedUser._id"
        (click)="selectUser(standings[0].user)"
      >
        <div class="podium-crown">👑</div>
        <div class="podium-medal">🥇</div>
        <div class="podium-avatar-wrap">
          <app-avatar [user]="standings[0].user"></app-avatar>
        </div>
        <div class="podium-name">{{ standings[0].user.name }}</div>
        @if (
          currentTimestamp >= firstRoundIniTimestamp &&
          standings[0].championFlag
        ) {
          <div
            class="podium-champion"
            title="Campeón: {{ standings[0].championName }}"
          >
            <img
              [src]="standings[0].championFlag"
              [alt]="standings[0].championName"
            />
            <span>{{ standings[0].championName }}</span>
          </div>
        }
        <div class="podium-pts">
          {{ standings[0].points }}<small>pts</small>
        </div>
        <div class="podium-jokers">
          {{ standings[0].jokersConsumed
          }}<img src="/assets/imgs/joker-on.svg" />
        </div>
        @if (
          currentTimestamp >= firstRoundIniTimestamp &&
          standings[0].pichichiLabel
        ) {
          <div class="podium-pichichi">
            <span class="podium-pichichi-icon">⚽</span>
            <span class="podium-pichichi-name">{{
              standings[0].pichichiLabel
            }}</span>
          </div>
        }
        @if (standings[0].currentResults) {
          <div class="podium-live">
            @for (r of standings[0].currentResults; track r) {
              <span
                >{{ getLivePredictionLabel(r) }}
                @if (r.useJoker) {
                  <img src="/assets/imgs/joker-on.svg" class="tiny-joker" />
                }
              </span>
            }
          </div>
        }
      </div>

      <div
        class="podium-card bronze"
        [class.is-me]="standings[2].user._id == loggedUser._id"
        (click)="selectUser(standings[2].user)"
      >
        <div class="podium-medal">🥉</div>
        <div class="podium-avatar-wrap">
          <app-avatar [user]="standings[2].user"></app-avatar>
        </div>
        <div class="podium-name">{{ standings[2].user.name }}</div>
        @if (
          currentTimestamp >= firstRoundIniTimestamp &&
          standings[2].championFlag
        ) {
          <div
            class="podium-champion"
            title="Campeón: {{ standings[2].championName }}"
          >
            <img
              [src]="standings[2].championFlag"
              [alt]="standings[2].championName"
            />
            <span>{{ standings[2].championName }}</span>
          </div>
        }
        <div class="podium-pts">
          {{ standings[2].points }}<small>pts</small>
        </div>
        <div class="podium-jokers">
          {{ standings[2].jokersConsumed
          }}<img src="/assets/imgs/joker-on.svg" />
        </div>
        @if (
          currentTimestamp >= firstRoundIniTimestamp &&
          standings[2].pichichiLabel
        ) {
          <div class="podium-pichichi">
            <span class="podium-pichichi-icon">⚽</span>
            <span class="podium-pichichi-name">{{
              standings[2].pichichiLabel
            }}</span>
          </div>
        }
        @if (standings[2].currentResults) {
          <div class="podium-live">
            @for (r of standings[2].currentResults; track r) {
              <span
                >{{ getLivePredictionLabel(r) }}
                @if (r.useJoker) {
                  <img src="/assets/imgs/joker-on.svg" class="tiny-joker" />
                }
              </span>
            }
          </div>
        }
      </div>
    </div>
  }

  @if (true) {
    <div class="st-list">
      @for (standing of standings; track standing; let i = $index) {
        @if (standings.length < 3 || i >= 3) {
          <div
            class="st-row"
            id="standings-{{ standing.user._id }}"
            (click)="selectUser(standing.user)"
            [class.is-me]="standing.user._id == loggedUser._id"
          >
            @if (
              currentTimestamp >= firstRoundIniTimestamp &&
              standing.championFlag
            ) {
              <div
                class="champ-bg"
                [ngStyle]="{
                  'background-image': standing.championFlag | asUrl,
                }"
              ></div>
            }
            <div class="st-rank">{{ i + 1 }}</div>
            <div class="st-avatar-wrap">
              <app-avatar [user]="standing.user"></app-avatar>
            </div>
            <div class="st-info">
              <span class="st-name">{{ standing.user.name }}</span>
              <div class="st-meta">
                @if (
                  currentTimestamp >= firstRoundIniTimestamp &&
                  standing.pichichiLabel
                ) {
                  <span class="st-pichichi"
                    >⚽ {{ standing.pichichiLabel }}</span
                  >
                }
                @if (standing.currentResults) {
                  @for (lr of standing.currentResults; track lr) {
                    <span class="st-live-result">
                      {{ getLivePredictionLabel(lr) }}
                      @if (lr.useJoker) {
                        <img
                          src="/assets/imgs/joker-on.svg"
                          class="tiny-joker"
                        />
                      }
                    </span>
                  }
                }
              </div>
            </div>
            <div class="st-change">
              <div
                class="change-arrow"
                [class.equal]="standing.posChange.change === 'equal'"
                [class.up]="standing.posChange.change === 'up'"
                [class.down]="standing.posChange.change === 'down'"
              ></div>
              <span class="change-num">{{ standing.posChange.number }}</span>
            </div>
            <div class="st-pts-col">
              <div class="st-pts">{{ standing.points }}</div>
              <div class="st-jokers">
                {{ standing.jokersConsumed
                }}<img src="/assets/imgs/joker-on.svg" />
              </div>
            </div>
          </div>
        }
      }
    </div>
  }
</div>

<block-ui></block-ui>
